import { prop } from 'ramda';
import { useCallback } from 'react';
import { useUserSelector } from 'js/store/hooks';

export const useGetBenefits = ({ bonusTemplate }) => {
    const { bonusConditions = [] } = bonusTemplate || {};
    const currencyCode = useUserSelector(prop('currencyCode'));

    return useCallback(({ value }) => {
        if (!bonusConditions) {
            return [];
        }

        const bonuses = [];
        const floatAmount = parseFloat(value);

        bonusConditions
            .flatMap(({ amounts }) => amounts)
            .filter((condition) => {
                const { fromAmount, toAmount } = condition;

                if (condition.currencyCode !== currencyCode) {
                    return false;
                }

                return fromAmount <= floatAmount && toAmount >= floatAmount;
            })
            .forEach((condition) => {
                const { bonusAmount, bonusPercent } = condition;

                if (bonusPercent) {
                    bonuses.push(bonusPercent);
                }

                if (bonusAmount) {
                    bonuses.push(bonusAmount);
                }
            });

        return bonuses;
    }, [
        bonusConditions,
        currencyCode
    ]);
};
